import {getToken, removeToken, setToken} from "@/utils/admin"
import {login} from "@/api/login/login"
import agencyGetInfo from "@/api/user/agency/agencyGetInfo";

const state = {
    token: getToken()
};

const mutations = {
    SET_TOKEN(state, token) {
        state.token = token
    }
};

const actions = {
    login({commit}, userInfo) {
        return new Promise( (resolve, reject) => {
            login(userInfo).then(res => {
                commit('SET_TOKEN', res.access_token);
                setToken(res.access_token);

                agencyGetInfo().then(res=>{
                    let info = res.data
                    localStorage.setItem("userinfo", JSON.stringify(info))
                    resolve()
                })

            }).catch(error => {
                reject(error)
            })
        })
    },
    logout({commit}) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '');
            removeToken();
            resolve()
        })
    }
};

export default {
    namespace: true,
    state,
    mutations,
    actions
}
